import React, { useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
// import Card from "react-bootstrap/Card";
import authApi from "../api/authApi";
import * as constants from "../constants/CONSTANT";
import logo_login from "./../assets/img/solis_power_banner.png";
import logo from "./../assets/img/solisPowerLogo.png";
import { validationMessages } from "../utils/messages";
import { regExPattern } from "../utils/regExPattern";
import { getUserDetails } from "../utils/helper";
import { ROUTES } from "../constants/webRouting";
const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [show, setShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [inputType, setInputType] = useState("email");
  const [validated, setValidated] = useState(false);
  const initialErrors = {
      email: { message: validationMessages.email.required },
      password: { message: validationMessages.password.required },
  };
  const [errors, setErrors] = useState(initialErrors);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handleSubmit 1 == ",credentials)
    // if (checkRequiredFields()) {
    //   setShowValidationMessage(true);
    //   return;
    // }

      if (checkRequiredFields()) {
          setValidated(true);
          return;
      }

    console.log("handleSubmit 2 == ",credentials)
    console.log("handleSubmit 2 == ",Object?.keys(errors)?.length)

      if (Object?.keys(errors)?.length != 0) {
          setValidated(true);
          return;
      }

      console.log("handleSubmit 3 == ",credentials)
    const result = await authApi.login(credentials.email, credentials.password);
    if (result.success) {
      // Fixed by Farhan Khan on 31-Jan-2026 - Role-based redirect after login
      // Get user details from token to check role
      const userInfo = getUserDetails();
      const userRole = userInfo?.userrole || userInfo?.role || userInfo?.user_role || null;
      
      // Redirect based on role
      // Super Admin → Home, Others → Lead List
      if (userRole === constants.SUPER_ADMIN || userRole === 'SUPER_ADMIN') {
        navigate(ROUTES.HOME);
      } else {
        navigate(ROUTES.LEAD.LIST);
      }
    } else {
      setShow(true);
      setErrorMessage(result.errors);
    }
  };

  // Added by shivani bug 69 1 july start
  // const checkRequiredFields = () => {
  //   return !credentials.email || !credentials.password;
  // };
  // Added by shivani bug 69 1 july end

  //Added by shahir hussain 28-08-2025
      const checkRequiredFields = () => {
          let isError = false;
          console.log("checkRequiredFields == ",credentials?.email)
          if (credentials?.email) {
              if(inputType === "number"){
                    setErrors((prev) => {
                        delete prev['email'];
                        return { ...prev };
                    });
              }
              else{
                if (credentials?.email == "") {
                    setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.required } }));
                    isError = true;
                }
                else if (regExPattern?.email && (!RegExp(regExPattern.email).test(credentials.email))) {
                    setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.invalid } }));
                    isError = true;
    
                } else {
                    setErrors((prev) => {
                        delete prev['email'];
                        return { ...prev };
                    });
                }
              }
          }
        

          if (credentials?.password) {
              if (credentials?.password == "") {
                  setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.required } }));
                  isError = true;
              } else if (regExPattern?.password && (!RegExp(regExPattern.password).test(credentials.password))) {
                  setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.invalid } }));
                  isError = true;
              } else {
                  setErrors((prev) => {
                      delete prev['password'];
                      return { ...prev };
                  });
              }
          }
  
          if (!credentials?.email) {
              setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.required } }));
              isError = true;
          }
          if (!credentials?.password) {
              setErrors((prev) => ({ ...prev, 'password': { message: validationMessages.password.required } }));
              isError = true;
          }

          console.log('isError', isError);
          return isError;
      }

  const handleChange = (e) => {
    let value = e.target.value;

      if(e.target.name ===  "email"){
            console.log("inputtype == ",inputType)
          if (/^[0-9]/.test(value[0])) {
          setInputType("number");
          value = value.replace(/[^0-9]/g, "").slice(0, 10);
            setErrors((prev) => {
                delete prev[e.target.name];
                return { ...prev };
            });
        } else {
          if (value == "") {
              setErrors((prev) => ({ ...prev, [e.target.name]: { message: validationMessages.email.required } }));
          } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
              setErrors((prev) => ({ ...prev, [e.target.name]: { message: validationMessages.email.invalid } }));
          } else {
              setErrors((prev) => {
                  delete prev[e.target.name];
                  return { ...prev };
              });
          }
          setInputType("email");
        }
      }else if (e.target.name === "password") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [e.target.name]: { message: validationMessages.password.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [e.target.name]: { message: validationMessages.password.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[e.target.name];
                    return { ...prev };
                });
            }
        }
        setValidated(true);
        setCredentials({ ...credentials, [e.target.name]: value });
    
  };
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 px-5 login-main-div">
      <Row className="login-form rounded shadow">
        <Col lg={6} className="p-0">
          <img
            src={logo_login}
            alt="Solis Power login image"
            className="mt-4 "
            style={{
              width: "95%",
              height: "57vh",
              borderTopLeftRadius: "5px",
              borderBottomLeftRadius: "5px",
              marginLeft: "20px"
            }}
          />
        </Col>
        <Col lg={6} className="login-section p-5">
          {/* <div className=" "> */}
          <Form 
            className=""
            onSubmit={handleSubmit}
            noValidate
            validated={validated}
            >
            <div className=" text-center  ">
              <img
              className="logo-img"
                src={logo}
                style={{ width: "34%" }}
                // className="mb-2"
                alt=""
              />
              {/* <div>Convert, before it fades away</div> */}
              <h3 className=" ">Login</h3>
            </div>
            <Alert variant="danger" show={show} className="error-alert">
              {errorMessage}
            </Alert>
            <Form.Group>
              <Form.Label
                className="form-view-label"
                htmlFor="formBasicEmail"
              >
                Email address or phone</Form.Label>
              <Form.Control
                type={inputType}
                name="email"
                onChange={handleChange}
                placeholder={inputType === "email" ? "Enter email" : "Enter phone"}
                value={credentials.email}
                pattern={regExPattern.email}
                isInvalid={validated} 
                // isInvalid={showValidationMessage && !credentials.email} // Added by shivani bug 69 1 july
              />
              <Form.Control.Feedback type="invalid">
                  {errors?.email?.message}
              </Form.Control.Feedback>
            </Form.Group>
            {console.log("errors == ",errors)}
            {console.log("setValidated == ",validated)}

            {/* // Added by shivani bug 69 1 july start */}
            {/* <Form.Control.Feedback type="invalid">
              Please enter your Email.
            </Form.Control.Feedback> */}
            {/* // Added by shivani bug 69 1 july end */}

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                onChange={handleChange}
                placeholder="Password"
                value={credentials.password}
                pattern={regExPattern.password}
                isInvalid={validated} 
                // isInvalid={showValidationMessage && !credentials.password} // Added by shivani bug 69 1 july
              />
              <Form.Control.Feedback type="invalid">
                  {errors?.password?.message}
              </Form.Control.Feedback>
            </Form.Group>
            {/* // Added by shivani bug 69 1 july start */}
            {/* <Form.Control.Feedback type="invalid">
              Please enter your password.
            </Form.Control.Feedback> */}
            {/* // Added by shivani bug 69 1 july end */}
            <Button variant="primary" type="submit">
              Login
            </Button>
          </Form>
          {/* <div className="pt-4 text-center"> */}
          {/* or Login with */}
          {/* <div className="pt-4">
             <a href="#">
              <span className="fa-stack fa-2x">
                <i
                  className="fa-solid fa-circle fa-stack-2x"
                  style={{ color: "#3b5998", fontSize : "4rem"}}
                ></i>
                <i className="fa-brands fa-facebook-f fa-stack-1x" style={{ color: "#fff", fontSize: "2rem" }}></i>
              </span> 
              </a>
              <a href="#">
              <span className="fa-stack fa-2x">
                <i
                  className="fa-solid fa-circle fa-stack-2x"
                  style={{ color: "tomato", fontSize : "4rem"}}
                ></i>
                <i className="fa-brands fa-google fa-stack-1x" style={{ color: "#fff", fontSize: "2rem" }}></i>
              </span>
              </a>
              <a href="#">
              <span className="fa-stack fa-2x">
                <i
                  className="fa-solid fa-circle fa-stack-2x"
                  style={{ color: "#0d95e8", fontSize : "4rem"}}
                ></i>
                <i className="fa-brands fa-twitter fa-stack-1x" style={{ color: "#fff", fontSize: "2rem" }}></i>
              </span>
              </a>
            </div> */}
          {/* </div> */}
          {/* </div> */}
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="text-center mt-3">
            <h6 className="text-center">Powered by</h6>
            <div className="d-flex justify-content-center align-items-center">
              <img
                alt=""
                src="ibirds-logo.jpeg"
                style={{
                  width: "150px",
                  height: "80px",
                  objectFit: "contain",
                  marginRight: "-18px",
                }}
              />
              <img
                alt=""
                src="indicrmlogo.png"
                style={{ width: "150px", height: "80px", objectFit: "contain" }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
